import React from 'react';
import PropTypes from 'prop-types';
import Spinner from 'react-spinkit';
import injectSheet from 'react-jss';

import styles from './styles/Loading';

export const Loading = ({ classes }) => {
    return (
        <div className={classes.spinnerContainer}>
            <Spinner name="three-bounce" color="#454B57" fadeIn="quarter" />
        </div>
    );
};

Loading.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default injectSheet(styles)(Loading);
